// @ts-nocheck

const dataURLtoFile = (dataUrl, filename) => {
  let n = bstr.length;

  const arr = dataUrl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

const share = (options) =>
  new Promise(async (resolve, reject) => {
    //  https://bugs.chromium.org/p/chromium/issues/detail?id=636274
    //  If the share promise is not resolved when focus is returned to
    //  the window, then resolve it after a 100ms delay.
    const cancel = () =>
      setTimeout(() => {
        window.removeEventListener('focus', cancel);
        resolve();
      }, 100);

    window.addEventListener('focus', cancel);

    try {
      await navigator.share(options);
      window.removeEventListener('focus', cancel);
      resolve();
    } catch (error) {
      // Differentiate between user 'AbortError' and internal errors.
      // E.g. Internal error: could not connect to Web Share interface.
      if (error.name.indexOf('AbortError') !== 0) {
        reject(error);
      }
    }
  });

// Trigger native sharing from a webapp. Only works on modern mobile browsers (at the moment chrome mobile >= v75)
const shareFile = (dataUrl, fileName) => {
  if (navigator.share) {
    const file = dataURLtoFile(dataUrl, fileName);
    return share({ files: [file] });
  } else {
    return Promise.reject();
  }
};

export default { shareFile, share };
